module.exports = __webpack_public_path__ + "media/luxury-2026/loch-front-facade-b6f3f019.jpg";